<template>
    <div>
        <div class="flex-space-between">
            <div v-if="info.wxbindflag === '1'">
                <span class="mr-8">{{ info.nickname ? info.nickname : "--" }}</span>
            </div>
            <div v-else>未开通</div>

            <div class="main cursor-pointer" v-on:click="handleClick">
                {{ info.wxbindflag === "1" ? "关闭" : "开通" }}
            </div>

            <!-- 交易密码弹窗 -->
        </div>
        <my-dialog
            class="my-dialog-contain"
            title="请输入交易密码"
            :visible="pwdDialogVisible"
            width="620px"
            :dialog-close="closePwdDialog"
        >
            <div class="acct-con">
                <el-form
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item prop="tradepassword" label="交易密码：" class="form-text">
                        <el-input
                            v-model.trim="pwdForm.tradepassword"
                            type="password"
                            show-password
                            maxlength="16"
                            placeholder="请输入交易密码"
                            class="input-pwd"
                            autocomplete="new-password"
                        />
                    </el-form-item>

                    <el-form-item>
                        <div class="btn-contain">
                            <button class="confirm-btn" v-on:click="submitPwdForm">确定</button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import userApi from "@/api/user";
import myDialog from "@/components/layout/myDialog.vue";
import { clearUrlQuery } from "@/util/url.js";
export default {
    name: "WxQuickLogin",
    components: {
        myDialog
    },
    props: {},
    data() {
        return {
            info: {},
            pwdDialogVisible: false,
            operate: "1", // 1-绑定 0-解绑
            pwdForm: {
                tradepassword: ""
            },
            rules: {
                tradepassword: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            }
        };
    },
    computed: {
        wxheadimageurl() {
            if (!this.wxheadimageid) return "";
            return this.$util.getFileDownloadUrl(this.wxheadimageid);
        }
    },
    mounted() {
        this.info = this.$cache.getUser();
        this.handleWxCallback();
    },
    methods: {
        handleClick() {
            if (this.info.wxbindflag === "1") {
                this.$confirm("关闭后，您将无法使用该微信进行快捷登录", "提示", {
                    type: "warning"
                }).then(() => {
                    this.operate = "0";
                    this.openPwdDialog();
                });
            } else {
                this.operate = "1";
                this.openPwdDialog();
            }
        },

        openPwdDialog() {
            this.pwdForm.tradepassword = "";
            this.pwdDialogVisible = true;
        },

        closePwdDialog() {
            this.pwdDialogVisible = false;
            this.pwdForm.tradepassword = "";
        },

        submitPwdForm() {
            this.$refs.pwdForm.validate(async (valid) => {
                if (!valid) {
                    this.$errorScroll && this.$errorScroll();
                    return;
                }
                const pwdRes = await userApi.combPasswordCheck({
                    tradepassword: this.$util.enc(this.pwdForm.tradepassword)
                });
                if (pwdRes.code != 0) {
                    return;
                }
                this.pwdDialogVisible = false;
                if (this.operate === "1") {
                    this.startWxAuth();
                } else {
                    this.unbindWx();
                }
            });
        },

        // 跳微信授权
        startWxAuth() {
            const wxAuthBaseUrl = this.$cache.getCompanyInfoParam("10107004");
            const appid = this.$cache.getCompanyInfoParam("10106016");
            const redirectUri = encodeURIComponent(window.location.href);
            sessionStorage.setItem("WX_TRADE_PWD", this.pwdForm.tradepassword);
            const authUrl =
                `${wxAuthBaseUrl}` +
                `?appid=${appid}` +
                `&redirect_uri=${redirectUri}` +
                `&response_type=code` +
                `&scope=snsapi_login` +
                `#wechat_redirect`;

            //  跳转
            window.location.href = authUrl;
        },

        // 授权回调绑定
        async handleWxCallback() {
            //  没有 code，直接 return
            if (!window.location.search.includes("code=")) return;

            const params = new URLSearchParams(window.location.search);
            const codes = params.getAll("code");
            const code = codes[codes.length - 1];

            // 没有交易密码，说明不是本次绑定流程
            const tradePwd = sessionStorage.getItem("WX_TRADE_PWD");
            if (!code || !tradePwd) return;

            // 防重复
            sessionStorage.removeItem("WX_TRADE_PWD");

            try {
                const res = await userApi.wechatOauthBind({
                    code,
                    tradepassword: this.$util.enc(tradePwd)
                });

                if (!res.data.flag) {
                    this.$message.success("已成功开通微信快捷登录功能");
                    await this.refreshUserInfo();
                } else if (res.data.flag == "1") {
                    this.$message.error("该微信已绑定其他账号");
                } else {
                    this.$message.error("数据异常，绑定失败");
                }
            } finally {
                //  统一出口：用公共 util
                clearUrlQuery("code");
            }
        },

        // 解绑
        async unbindWx() {
            const res = await userApi.wechatOauthBind({
                operate: "0",
                tradepassword: this.$util.enc(this.pwdForm.tradepassword)
            });

            if (!res.data) {
                this.$message.success("微信快捷登录已关闭");
                await this.refreshUserInfo();
            } else {
                this.$message.error("关闭失败，请稍后重试");
            }
        },
        updateInfo() {
            this.$cache.refreshUser(() => {
                this.info = this.$cache.getUser();
                this.$store.dispatch("setInfo", this.info);
            });
        },
        refreshUserInfo() {
            return new Promise((resolve) => {
                this.$cache.refreshUser(() => {
                    const user = this.$cache.getUser();
                    this.info = user;
                    this.$store.dispatch("setInfo", user);
                    this.$emit("refreshInfo");
                    resolve(user);
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.flex-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.wx-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-left: 8px;
}
.mr-8 {
    margin-right: 8px;
}
.cursor-pointer {
    cursor: pointer;
}

/* 复用系统弹窗样式 */
.acct-con {
    padding: 40px 40px 20px;
    :deep(.el-form-item__label) {
        width: 90px;
        text-align: right;
        padding: 0;
        color: #999;
    }
    .form-text {
        .input-pwd {
            margin-left: 10px;
            width: 416px;
        }
    }
    .btn-contain {
        text-align: center;
        margin-top: 30px;
        .confirm-btn {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: #e60012;
            border: 1px solid #e60012;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            cursor: pointer;
        }
    }
}
</style>
